import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { type ComponentProps } from 'react'

import { cn } from '@/shared/lib'
import { Button, Icon } from '@/shared/ui'

export const Root = ({
  className,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Root>) => {
  return <AccordionPrimitive.Root className={cn(className)} {...props} />
}

export const Item = ({
  className,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Item>) => {
  return (
    <AccordionPrimitive.Item
      className={cn(
        'rounded-lg bg-white shadow-[0_1px_8px_0_rgba(0,0,0,0.10)]',
        className,
      )}
      {...props}
    />
  )
}

export const Trigger = ({
  className,
  children,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Trigger>) => {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        className={cn(
          'typo-headline3 flex w-full cursor-pointer items-center justify-between gap-3 px-6 py-5 font-semibold transition-all',
          'ring-offset-background focus-visible:ring-ring rounded-sm focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none',
          '[&[data-state=open]>svg]:rotate-180',
          className,
        )}
        {...props}
      >
        {children}
        <Button
          variant="outline"
          size="small"
          shape="pill"
          className="h-8 w-8 shrink-0 p-2 transition-transform duration-200"
          asChild
        >
          <Icon name="arrow-bottom" size={16} />
        </Button>
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  )
}

export const Content = ({
  className,
  children,
  ...props
}: ComponentProps<typeof AccordionPrimitive.Content>) => {
  return (
    <AccordionPrimitive.Content
      className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden"
      {...props}
    >
      <div
        className={cn(
          'typo-body1-reading pr-6 pb-5 pl-12 whitespace-break-spaces text-gray-900',
          className,
        )}
      >
        {children}
      </div>
    </AccordionPrimitive.Content>
  )
}
